// extracted by mini-css-extract-plugin
export default {"backofficeLayout":"BackofficeLayout_backofficeLayout__QGzJL","content":"BackofficeLayout_content__WWI3d"};